// @flow
import * as React from 'react';
import { ApiFormWithModel } from 'esm-web-pro/containers/forms/FormWithModel';
import type { Cable } from 'esm-web-pro/types/networks';

type Props = {
    cable: Cable,
    onClose: Function,
    onSave: Function,
};

const PatchCableEditor = (props: Props) => {
    const { cable, onClose, onSave } = props;
    const formRef = React.useRef(null);

    const extraSchema = {};
    if (cable.connected_fibers.find((fiber) => !!fiber.start_termination_point)) {
        extraSchema.start_termination_point = { validation: { disabled: true } };
    }
    if (cable.connected_fibers.find((fiber) => !!fiber.end_termination_point)) {
        extraSchema.end_termination_point = { validation: { disabled: true } };
    }

    return (
        <ApiFormWithModel
            forwardRef={formRef}
            resourceName="patchCable"
            resourceArguments={[cable.start_container_point.uuid]}
            objectId={cable.uuid}
            excludeFields={['infrastructure_provider', 'model']}
            extraSchema={[extraSchema]}
            height="100%"
            onClose={onClose}
            onSave={onSave}
        />
    );
};

export default PatchCableEditor;
